import i18n from "i18next";
import { isAdmin } from "@/constants";
import { isPlatform, platformMostAI } from "@/domains.ts";

export interface MenuItem {
  title?: string;
  icon?: string;
  iconExtraClasses?: string;
  iconSize?: string;
  link?: string;
  isBotSelector?: boolean;
  isHeadr?: boolean;
  isNew?: boolean;
}

export const menuItems = ({
  chatbotID,
  userID,
}: {
  chatbotID: string | null;
  userID: string | null;
}): MenuItem[] => {
  let res = [
    {
      title: "Home",
      icon: "fluent:home-20-regular",
      link: "dashboard",
    },
    {
      title: "Playground",
      icon: "fluent:window-console-20-regular",
      link: "playground",
      iconSize: "30px",
    },
    {
      title: "AI Assistant",
      icon: "fluent:bot-sparkle-20-regular",
      link: "chat",
      iconSize: "30px",
    },
    {
      title: "Analytics",
      icon: "fluent:data-usage-20-regular",
      link: "analytics",
      iconSize: "30px",
    },
    {
      title: "Sessions",
      icon: "fluent:task-list-ltr-20-filled",
      link: "sessions",
    },
    {
      title: "Extensions",
      icon: "fluent:extension-20-regular",
      link: "extensions",
      iconSize: "30px",
    },
    {
      title: "Settings",
      icon: "fluent:settings-cog-multiple-20-regular",
      link: "settings",
      iconSize: "30px",
    },
    {
      title: "Docs",
      icon: "fluent:book-question-mark-20-regular",
      link: "docs",
      iconSize: "30px",
    },
    {
      title: "ИИ чатботы",
      icon: "fluent:bot-24-regular",
      link: "my-assistants",
      platform: platformMostAI,
    },
    {
      title: i18n.t("integrations"),
      icon: "fluent:layer-20-regular",
      link: "chatbot/integrations",
      platform: platformMostAI,
    },
    // {
    //   title: i18n.t("custom-chats-header"),
    //   icon: "fluent:apps-add-in-20-regular",
    //   link: "chat",
    // },
    // {
    //   title: i18n.t("custom-chats-header"),
    //   icon: "fluent:apps-add-in-20-regular",
    //   link: "chat/explore",
    // },
    // {
    //   isBotSelector: true,
    // },
    {
      isHeadr: true,
      title: i18n.t("sidebar.chabot"),
    },
    {
      title: i18n.t("sidebar.playground"),
      isHide: true,
      icon: "fluent:bot-20-regular",
      link: "chatbot/{chatbot_id}/playground",
    },
    {
      title: i18n.t("sidebar.ai_settings"),
      isHide: true,
      icon: "fluent:brain-circuit-20-regular",
      link: "chatbot/{chatbot_id}/ai_settings",
    },
    {
      isHeadr: true,
      title: i18n.t("sidebar.chat_widget"),
    },
    // {
    //   title: "Dashboard",
    //   isHide: true,
    //   icon: "radix-icons:dashboard",
    //   link: "chatbot/{chatbot_id}/dashboard",
    // },
    {
      title: i18n.t("sidebar.publish_chatbot"),
      isHide: true,
      icon: "fluent:share-ios-20-regular",
      link: "chatbot/{chatbot_id}/publish_chatbot",
    },
    {
      title: i18n.t("sidebar.chat_interface"),
      isHide: true,
      icon: "fluent:design-ideas-20-filled",
      link: "chatbot/{chatbot_id}/design",
    },
    {
      isHeadr: true,
      title: i18n.t("sidebar.leads"),
    },
    {
      title: i18n.t("sidebar.conversations"),
      isHide: true,
      icon: "fluent:chat-multiple-20-regular",
      link: "chatbot/{chatbot_id}/conversations",
    },
    {
      title: i18n.t("sidebar.leads"),
      isHide: true,
      icon: "fluent:people-team-20-regular",
      link: "chatbot/{chatbot_id}/leads",
    },
    {
      isHeadr: true,
      title: i18n.t("sidebar.knowledge_base"),
    },
    {
      title: i18n.t("sidebar.web_pages"),
      isHide: true,
      icon: "ph:link",
      iconExtraClasses: "ml-0.5",
      link: "chatbot/{chatbot_id}/sources/links",
    },
    {
      title: i18n.t("sidebar.files"),
      isHide: true,
      icon: "fluent:document-one-page-multiple-20-regular",
      iconSize: "30px",
      iconExtraClasses: "",
      link: "chatbot/{chatbot_id}/sources/files",
    },
    {
      title: i18n.t("sidebar.qa"),
      isHide: true,
      icon: "wpf:faq",
      link: "chatbot/{chatbot_id}/sources/question",
    },
    {
      title: i18n.t("sidebar.text"),
      isHide: true,
      icon: "fluent:text-abc-underline-double-32-regular",
      link: "chatbot/{chatbot_id}/sources/text",
    },
    {
      isHeadr: true,
      title: i18n.t("sidebar.advanced"),
    },
    {
      title: i18n.t("sidebar.integrations"),
      isHide: true,
      icon: "fluent:layer-20-regular",
      link: "chatbot/{chatbot_id}/integrations",
    },
    {
      title: i18n.t("sidebar.settings"),
      isHide: true,
      icon: "fluent:settings-16-regular",
      link: "chatbot/{chatbot_id}/settings",
    },
  ];

  if (isAdmin(userID)) {
    res.push({
      title: "Catalog Settings",
      isHide: true,
      icon: "fluent:text-bullet-list-square-16-regular",
      link: "chatbot/{chatbot_id}/catalog-settings",
    });
  }

  return res
    .map((item) => {
      if (item.platform && !isPlatform(item.platform)) {
        return null;
      }

      if (item.isHeadr && !chatbotID) {
        return null;
      }

      if (!item.link) {
        return item;
      }

      if (item.link.indexOf("{chatbot_id}") !== -1 && !chatbotID) {
        return null;
      }

      item.link = item.link.replace("{chatbot_id}", chatbotID);
      return item;
    })
    .filter((item) => item) as MenuItem[];
};
